/** Shared react-query cache options for the research-hook family
 *  (usePlayerResearch, useBullpenData, useMatchupData, …). Spread into
 *  useQuery; deviations (e.g. useH2H's 60min for static career data)
 *  stay inline so they read as deliberate. */
export const RESEARCH_QUERY_OPTIONS = {
  staleTime: 10 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
  retry: 1,
} as const;
